import { useFlags } from "launchdarkly-react-client-sdk";

import {
  SCHEDULING_V2_FEATURE,
  SCHEDULING_V21_FEATURE
} from "constants/feature-flags";

export function useScheduleExperience() {
  const flags = useFlags();
  const isScheduleV2Enabled = Boolean(flags[SCHEDULING_V2_FEATURE]);
  const isSchedule21Enabled =
    isScheduleV2Enabled && Boolean(flags[SCHEDULING_V21_FEATURE]);
  return { isScheduleV2Enabled, isSchedule21Enabled };
}
